import { InitialCausalityFilter } from '../../../../../shared/types/typifications/initialCausality';

export const initialValues: InitialCausalityFilter = {
    id: '',
    product: [],
    motive: [],
    submotive1: '',
    submotive2: '',
    submotive3: '',
    submotive4: '',
    typeComplaint: '',
    active: true,
    // typePqr:[],
};
